// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiLifetime {
    static getAttributeTypeMap() {
        return MedicalBiLifetime.attributeTypeMap;
    }
}
MedicalBiLifetime.discriminator = undefined;
MedicalBiLifetime.additionalProperties = false;
MedicalBiLifetime.attributeTypeMap = [
    {
        "name": "maxAmount",
        "baseName": "maxAmount",
        "type": "number"
    },
    {
        "name": "maximumExists",
        "baseName": "maximumExists",
        "type": "string"
    },
    {
        "name": "maxMet",
        "baseName": "maxMet",
        "type": "number"
    },
];
//# sourceMappingURL=medicalBiLifetime.js.map